import axiosInstance from "../http/axios_instance"
const http = axiosInstance("/protected/customer/",  null, "/dashboard")

const getOrganisation = () => http.get("/organisation");

export default {
    getOrganisation
}
